
import React, { useContext, useEffect, useState } from "react";
import { Button, Dialog} from "primereact";

import AgGrid from "../../../../Components/Tables/AgGrid/AgGrid";
import { getLabel } from "../../../../Services/Language/LanguageService";
import { baseLang } from "../../../../Lang/BaseLang";
import { ConfigContext } from "../../../../Context/ConfigContext/ConfigContext";

import { RolesConPermiso, UsuariosConPermiso } from "../../../../API/IT/Permisos/PermisosRequests";
import { TabPanel, TabView } from "primereact/tabview";

const PermisosUser = ({
    showDialogUser,
    setShowDialogUser,
    selected,
}) => {

    
  const { config } = useContext(ConfigContext);
  const [userAccess, setUserAccess] = useState([]);
  const [rolAccess, setRolAccess] = useState([]);
  const [loading, setLoading] = useState(false);


  const hideDialog = () => {
    setShowDialogUser(false);
  };

  const getInfo = async () => {
    setLoading(true);
    const result = await UsuariosConPermiso(selected?.IdMenu);
    setUserAccess(result);
    const resultado = await RolesConPermiso(selected?.IdMenu);
    setRolAccess(resultado);
    setLoading(false);
  };

  useEffect(() => {
    getInfo();
  }, [showDialogUser]);


const columns = [
    {
        header: 'ID Usuario',
        headerEn:'ID User',
        field: 'IdUser',
        className: 'Xsmall'
    },
    {
        header: 'Nombre Usuario',
        headerEn:'User Name',
        field: 'UserName',
    },
    {
        header: 'Nombre Usuario',
        headerEn:'User Name',
        field: 'UserName',
    },
    {
        header: 'Rol',
        headerEn:'Rol',
        field: 'Rol',
    },
    {
        header: 'Código Personal',
        headerEn:'Personal Code',
        field: 'IdPersonal',
    },
];

const table = {
    Columns: columns,
    Data: userAccess,
    loading: loading,
  };


  const columnsRoles = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdRol",
      className: "Xsmall",
    },
    {
      header: "Rol",
      headerEn: "Role",
      field: "Rol",
    },
    {
      header: "Descripción",
      headerEn: "Description",
      field: "Description",
    },
  ];

  const tableRoles = {
    Columns: columnsRoles,
    Data: rolAccess,
    loading: loading,
  };

  return (
    <div>
    <Dialog
      visible={showDialogUser}
      style={{ width: "50vw", height: "65vh" }}
      breakpoints={{ "960px": "75vw", "640px": "100vw" }}
      onHide={hideDialog}
    >
        <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <h3 style={{ marginRight: "1rem" }}>
          {getLabel(baseLang, "userPermiso", config.language)}{" "}
          {selected?.Menu}
        </h3>
        <Button icon="pi pi-refresh" onClick={getInfo} />
      </div>


      <TabView>
        <TabPanel header="Usuarios con Permiso">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          ></div>
          <div style={{ height: "50vh" }}>
            <AgGrid table={table} />
          </div>
        </TabPanel>
        <TabPanel header="Roles con Permiso">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1rem",
            }}
          ></div>
          <div style={{ height: "50vh" }}>
            <AgGrid table={tableRoles} />
          </div>
        </TabPanel>
      </TabView>
    </Dialog>
  </div>
  );
};

export default PermisosUser;
